import { render, staticRenderFns } from "./CostStatistic.vue?vue&type=template&id=2e8a6ad4&"
import script from "./CostStatistic.vue?vue&type=script&lang=js&"
export * from "./CostStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports